import { useAuth } from '@/lib/auth/auth';
import { organizationKeys } from '@/features/workspaces/useOrganization';
import { organizationInvitationKeys } from '@/features/workspaces/useOrganizationInvitations';
import { organizationMemberKeys } from '@/features/workspaces/useOrganizationMembers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type RemoveOrganizationMemberInput = {
  organizationID: string;
  userID: string;
};

export function useRemoveOrganizationMember() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationID, userID }: RemoveOrganizationMemberInput) =>
      request<void>(`/organizations/${organizationID}/members/${userID}`, {
        method: 'DELETE',
      }),
    onSuccess: async (_result, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: organizationMemberKeys.list(variables.organizationID),
        }),
        queryClient.invalidateQueries({
          queryKey: organizationInvitationKeys.list(variables.organizationID),
        }),
        queryClient.invalidateQueries({
          queryKey: organizationKeys.detail(variables.organizationID),
        }),
      ]);
    },
  });
}
